// see : https://stackoverflow.com/questions/8572826/generic-deep-diff-between-two-objects
// see : http://jsfiddle.net/cs5d3uwn/

const VALUE_CREATED = 'created'
const VALUE_UPDATED = 'updated'
const VALUE_DELETED = 'deleted'
const VALUE_UNCHANGED = 'unchanged'

export const map = (obj1: any, obj2: any) => {
  if (isFunction(obj1) || isFunction(obj2)) {
    throw 'Invalid argument. Function given, object expected.'
  }
  if (isValue(obj1) || isValue(obj2)) {
    return {
      type: compareValues(obj1, obj2),
      data: obj1 === undefined ? obj2 : obj1,
    }
  }

  let diff: any = {}
  for (let key in obj1) {
    if (isFunction(obj1[key])) {
      continue
    }

    let value2 = undefined
    if (obj2[key] !== undefined) {
      value2 = obj2[key]
    }

    diff[key] = map(obj1[key], value2)
  }
  for (let key in obj2) {
    if (isFunction(obj2[key]) || diff[key] !== undefined) {
      continue
    }

    diff[key] = map(undefined, obj2[key])
  }

  return diff
}

const compareValues = (value1: any, value2: any) => {
  if (value1 === value2) {
    return VALUE_UNCHANGED
  }
  if (
    isDate(value1) &&
    isDate(value2) &&
    value1.getTime() === value2.getTime()
  ) {
    return VALUE_UNCHANGED
  }
  if (value1 === undefined) {
    return VALUE_CREATED
  }
  if (value2 === undefined) {
    return VALUE_DELETED
  }
  return VALUE_UPDATED
}

export const isFunction = (x: any) => {
  return Object.prototype.toString.call(x) === '[object Function]'
}
export const isArray = (x: any) => {
  return Object.prototype.toString.call(x) === '[object Array]'
}
export const isDate = (x: any) => {
  return Object.prototype.toString.call(x) === '[object Date]'
}
export const isObject = (x: any) => {
  return Object.prototype.toString.call(x) === '[object Object]'
}
export const isValue = (x: any) => {
  return !isObject(x) && !isArray(x)
}

export const testDeepDiffMapper = () => {
  let result = map(
    {
      a: 'i am unchanged',
      b: 'i am deleted',
      e: {
        a: 1,
        b: false,
        c: null,
      },
      f: [
        1,
        {
          a: 'same',
          b: [
            {
              a: 'same',
            },
            {
              d: 'delete',
            },
          ],
        },
      ],
      g: new Date('2017.11.25'),
    },
    {
      a: 'i am unchanged',
      c: 'i am created',
      e: {
        a: '1',
        b: '',
        d: 'created',
      },
      f: [
        {
          a: 'same',
          b: [
            {
              a: 'same',
            },
            {
              c: 'create',
            },
          ],
        },
        1,
      ],
      g: new Date('2017.11.25'),
    },
  )
  console.log(result)
}
